<template>
  <ontick-modal-component
    :open="isOpen"
    size="xs"
    @close="$emit('close')"
    :showCloseButton="true"
    title="Volume das operações"
  >
    <div class="grid grid-cols-12 gap-6 mt-6">
      <!-- <div class="col-span-12 pb-3 border-b border-ontick-steel-500">
        <h1 class="text-lg font-medium text-gray-50">Volume das operações</h1>
      </div> -->

      <div class="col-span-12">
        <label :for="`volume_${hashId}`" class="text-sm text-gray-300 leading-relaxed">Número de contratos</label>

        <div class="flex items-center gap-2 mt-1">
          <div class="relative w-full">
            <input
              type="text"
              v-model="volume"
              class="w-full px-3 py-2 text-sm bg-ontick-carbon-500 disabled:bg-ontick-steel-500 text-gray-50 disabled:text-gray-500 disabled:font-semibold rounded-lg border border-transparent disabled:border-ontick-steel-400 disabled:cursor-not-allowed focus:border-ontick-blue-500 focus:ring-0 focus:outline-none shadow-sm"
              placeholder="Contratos"
              :id="`volume_${hashId}`"
              @input="changeInput($event)"
              maxlength="19"
              v-money="money"
              :disabled="mode === 'EDIT_SCHEDULE'"
            />
            <span v-if="mode === 'EDIT_SCHEDULE'" class="absolute right-2 top-2 text-sm text-gray-500"
              >(troca agendada)</span
            >
          </div>

          <button
            class="border p-1.5 rounded-lg"
            :class="{
              'text-gray-500 bg-ontick-steel-500 border-ontick-steel-400 cursor-not-allowed':
                mode === 'CREATE_SCHEDULE' ? buttonDisabled : true,
              'text-ontick-blue-600 bg-ontick-carbon-500 border-ontick-steel-500':
                mode === 'CREATE_SCHEDULE' && !buttonDisabled,
            }"
            :style="
              (mode === 'CREATE_SCHEDULE' ? buttonDisabled : true)
                ? ''
                : 'box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.8)'
            "
            :disabled="mode === 'CREATE_SCHEDULE' ? buttonDisabled : true"
            v-tippy="{ arrow: true, theme: 'green' }"
            content="Resetar volume das operações"
            @click="volume = min_volume.toString()"
          >
            <i v-html="$icons.reset_edit_volume"></i>
          </button>
        </div>

        <p class="text-xs text-right mt-2 text-gray-400">Apenas múltiplos de {{ volume_step }}.</p>

        <span v-if="error.length" class="text-xs font-medium text-ontick-red-500">{{ error }}</span>

        <p class="text-xs leading-relaxed text-ontick-yellow-700 mt-6">
          ATENÇÃO: esta alteração será realizada após o horário de pregão, enquanto o mercado estiver fechado.
        </p>
      </div>
    </div>

    <template slot="footer">
      <div class="flex justify-end pt-4 mt-6 gap-4 border-t border-ontick-steel-500">
        <!-- <button
          class="w-full px-4 py-2 rounded-lg bg-transparent border border-ontick-steel-400 text-gray-300 font-normal focus:outline-none focus:ring-0 shadow-lg transition-all duration-150 ease-in-out"
          @click="$emit('close')"
        >
          Cancelar
        </button> -->
        <button
          class="w-full px-4 py-2 rounded-lg border font-normal whitespace-nowrap focus:outline-none focus:ring-0 shadow-lg transition-all duration-150 ease-in-out"
          :class="{
            'bg-ontick-steel-500 border-ontick-steel-400 text-gray-500 cursor-not-allowed': buttonDisabled,
            'bg-ontick-blue-900 border-ontick-blue-900 text-gray-50 hover:bg-ontick-blue-700 hover:border-ontick-blue-700':
              !buttonDisabled,
          }"
          :disabled="buttonDisabled"
          @click="mode === 'CREATE_SCHEDULE' ? confirm() : cancel()"
        >
          {{ mode === "CREATE_SCHEDULE" ? "Confirmar" : "Cancelar agendamento" }}
        </button>
      </div>
    </template>
  </ontick-modal-component>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { VMoney } from "v-money";
import OntickModalComponent from "../../../../../shared/components/basic/ontick-modal.component.vue";

export default {
  name: "ModalEditVolumeComponent",

  directives: { money: VMoney },

  components: {
    OntickModalComponent,
  },

  props: {
    mode: {
      type: String,
      default: "CREATE_SCHEDULE",
      validator: (value) => ["CREATE_SCHEDULE", "EDIT_SCHEDULE"].includes(value),
    },

    isOpen: {
      type: Boolean,
      default: false,
    },

    data: {
      type: Object,
      default: () => ({}),
    },
  },

  watch: {
    mode: {
      deep: true,
      handler() {
        const current_volume = this.data.type === "PORTFOLIO" ? this.data.max_exposure : this.data.curr_volume;
        this.volume =
          this.mode === "CREATE_SCHEDULE"
            ? current_volume.toString()
            : this.data.pending_schedule.sc_new_volume.toString();
      },
    },
  },

  data() {
    return {
      volume: "0",
      min_volume: this.data.min_volume,
      volume_step: this.data.volume_step,
      max_absolute_volume: this.data.max_absolute_volume,
      curr_volume: this.data.type === "PORTFOLIO" ? this.data.max_exposure : this.data.curr_volume,

      //money: usado na diretiva VMoney
      money: {
        decimal: ",",
        thousands: ".",
        // prefix: "R$ ",
        // suffix: "",
        precision: 0, // número de casas decimais
        masked: false, // se true, o valor será mascarado com os separadores de milhar e decimal
      },
      error: "",
    };
  },

  computed: {
    ...mapGetters({
      selectedAccount: "accountTypes/getSelectedAccount",
    }),

    buttonDisabled() {
      if (this.mode === "EDIT_SCHEDULE") {
        return;
      }

      const isDefault = Number(this.volume) === Number(this.curr_volume);
      return !this.volume || this.error.length > 0 || isDefault;
    },

    hashId() {
      return Math.random().toString(36).substring(2, 8).toUpperCase();
    },
  },

  methods: {
    ...mapActions({
      getInvestments: "investment/getInvestments",
    }),

    changeInput(e) {
      const value = Number.parseFloat(e.target.value.replace(/[^0-9,]/g, "").replace(",", "."));
      this.validateInput(value);
    },

    validateInput(value) {
      if (value % this.volume_step !== 0) {
        this.error = `Volume deve ser múltiplo de ${this.volume_step}`;
        return;
      }

      if (value < this.min_volume) {
        this.error = `Volume mínimo permitido é ${this.min_volume}`;
        return;
      }

      if (value > this.max_absolute_volume) {
        this.error = `Volume máximo permitido é ${this.max_absolute_volume}`;
        return;
      }

      this.error = "";

      return true;
    },

    async confirm() {
      const new_value = Number.parseFloat(this.volume.replace(/[^0-9,]/g, "").replace(",", "."));

      if (!this.validateInput(new_value)) {
        return;
      }

      const body = {
        account_id: this.selectedAccount.account_id,
        investment_id: this.data.investment_id,
        num_contracts: new_value,
      };

      try {
        const { data } = await this.$api.post(this.$endpoint.INVESTMENTS_VOLUME_SCHEDULE, body);
        this.getInvestments();
        this.$emit("close");
        this.$swal({
          title: "Sucesso",
          text: data.msg,
          icon: "success",
        });
      } catch (error) {
        this.$swal({
          title: "Erro",
          text: error?.data?.msg || "Erro na operação",
          icon: "error",
        });
      }
    },

    async cancel() {
      const body = {
        account_id: this.selectedAccount.account_id,
        investment_id: this.data.investment_id,
      };

      try {
        const { data } = await this.$api.post(this.$endpoint.INVESTMENTS_VOLUME_SCHEDULE_CANCEL, body);
        this.getInvestments();
        this.$emit("reopen", { investment_id: this.data.investment_id });
        this.$swal({
          title: "Sucesso",
          text: data.msg,
          icon: "success",
        });
      } catch (error) {
        this.$swal({
          title: "Erro",
          text: error?.data?.msg || "Erro na operação",
          icon: "error",
        });
      }
    },
  },

  created() {
    const current_volume = this.data.type === "PORTFOLIO" ? this.data.max_exposure : this.data.curr_volume;
    this.volume =
      this.mode === "CREATE_SCHEDULE" ? current_volume.toString() : this.data.pending_schedule.sc_new_volume.toString();
  },
};
</script>
